import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'

import { BlueBox as BlueBoxComponent } from '../../../InfoBox'
import { Padding } from '../../..'
import { mediaQueryForBigger, withSize } from '../../../utils'
import { colors } from '../../../../constants'

const BlueBox = styled(BlueBoxComponent)`
    overflow: visible;
`

const FlexBox = styled.div`
    ${mediaQueryForBigger.mobile(`
    display: flex;
    justify-content: space-between;
  `)}
`

const HeaderLabel = styled.span`
    color: ${colors.greylighter};
`

const Header = ({ t }) => (
    <BlueBox noFooter>
        <Padding fullHeight>
            <FlexBox>
                <div>
                    <HeaderLabel>{t('DASHBOARD')}</HeaderLabel>
                </div>
            </FlexBox>
        </Padding>
    </BlueBox>
)

Header.propTypes = {
    t: PropTypes.func.isRequired,
}

export default withSize(withTranslation()(Header))
